// Registry of supported languages. To add a language: append here + add locales/<code>.json (fallback is English).
export const LANGUAGES = [
  { code: "en-IN", native: "English", english: "English" },
  { code: "hi-IN", native: "हिन्दी", english: "Hindi" },
  { code: "ta-IN", native: "தமிழ்", english: "Tamil" },
  { code: "mr-IN", native: "मराठी", english: "Marathi" },
  { code: "kn-IN", native: "ಕನ್ನಡ", english: "Kannada" },
  { code: "bn-IN", native: "বাংলা", english: "Bengali" },
  { code: "te-IN", native: "తెలుగు", english: "Telugu" },
  { code: "gu-IN", native: "ગુજરાતી", english: "Gujarati" },
  { code: "pa-IN", native: "ਪੰਜਾਬੀ", english: "Punjabi" },
  { code: "ml-IN", native: "മലയാളം", english: "Malayalam" },
  { code: "or-IN", native: "ଓଡ଼ିଆ", english: "Odia" },
  { code: "as-IN", native: "অসমীয়া", english: "Assamese" },
];
export const DEFAULT_LANG = "en-IN";
export const STORAGE_KEY = "dpdp.lang";

let current = DEFAULT_LANG;
export const getLocale = () => current;
export const setLocale = (c) => { current = c; };
